export default __webpack_public_path__ + "static/media/luiz-felipe.42154eae.jpg";